export const Page2 = () => {
    return <div>Page2</div>
}